import React from 'react';
import PropTypes from 'prop-types';
import { OutlineButton } from '../../@communityshare/ui/Button';
import { SolidButton } from '../../@communityshare/ui/Button';
import FormTemplate from '../../dialogs_common/FormTemplate';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';
import TeamContact from '../../pages/settings-support-questions/SupportQuestion/TeamContact';

Form.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};

Form.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function Form(props) {
  const {
    data,
    errors,
    showErrors,
    alert,
    onChange,
    onSubmit,
    onClose,
    networkSupportQuestion
  } = props;

  return (
    <FormTemplate
      textAlign="left"
      title="Delete support contact"
      subtitle={(
        <>
          <span className="block">
            Are you sure you want to remove the following support contact?
          </span>
        </>
      )}
      onClose={onClose}
      alert={alert}
      body={(
        <TeamContact
          networkSupportQuestion={networkSupportQuestion}
          showButtons={false}
        />
      )}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onClose}>
            Cancel
          </OutlineButton>
          <SolidButton onClick={onSubmit}>
            Delete support contact
          </SolidButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
